import React from 'react'
import { Select as AntdSelect } from 'antd'
import classNames from 'classnames'
import { useController, UseControllerProps } from 'react-hook-form'
import {
  SelectProps as AntdSelectProps,
  OptionProps as AntdOptionProps,
  SelectValue,
  OptGroupProps,
} from 'antd/lib/select'

import { Modify } from 'helpers/typings'

import './index.less'

const Select: SelectFC = (props) => {
  const {
    name,
    className,
    defaultValue,
    children,
    rules = {},
    transformValue,
    ...restProps
  } = props

  const {
    field: {
      onChange,
      value,
      ref,
      onBlur,
    },
    fieldState: { invalid },
  } = useController({
    name,
    rules,
    defaultValue,
  })

  return (
    <AntdSelect
      {...restProps}
      ref={ref}
      onChange={(value: SelectValue) => onChange(transformValue ? transformValue(value) : value)}
      onBlur={(value: SelectValue) => {
        onBlur()

        if (restProps.onBlur) {
          restProps.onBlur(value)
        }
      }}
      value={value}
      className={classNames(className, 'form__select', {
        'form__select--invalid': invalid,
      })}
    >
      {children}
    </AntdSelect>
  )
}

Select.Option = AntdSelect.Option

Select.OptGroup = AntdSelect.OptGroup

type SelectFC = React.FC<SelectProps>
  & { Option: React.ClassicComponentClass<AntdOptionProps> }
  & { OptGroup: React.ClassicComponentClass<OptGroupProps> }

interface SelectProps extends Modify<AntdSelectProps, { onBlur?: (value: SelectValue) => void, }> {
  name: string,
  transformValue?: (value: SelectValue) => SelectValue,
  defaultValue?: string | number | Array<string> | Array<number>,
  className?: string,
  children?: React.ReactNode,
  rules?: UseControllerProps['rules'],
}

export default Select
